import { render, staticRenderFns } from "./FormDesignation.vue?vue&type=template&id=2f11fbe3"
import script from "./FormDesignation.vue?vue&type=script&lang=js"
export * from "./FormDesignation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports